import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'getAccessLevels');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'access_levels',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/getAccessLevels.js